// extracted by mini-css-extract-plugin
export default {"good_live_preheat_wrap":"index_good_live_preheat_wrap__4QrOv"};